import { useParams } from 'react-router-dom'
import useLoadListing from './use-load-listing'

// globalize
const useParamsLoadListing = () => {
  const { listingId } = useParams<{ listingId: string }>()
  const { listing, isLoading } = useLoadListing({ listingId })
  return { listing, listingId, isLoading }
}

export default useParamsLoadListing
